import * as Types from '../../../../../generated/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetClaimQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetClaimQuery = { __typename?: 'Query', claim?: { __typename?: 'Claim', id?: string | null, clientId?: string | null, clientClaimId?: string | null, stage?: string | null, status?: string | null, tlIndicator?: boolean | null, maximumRepairSpend?: number | null, policyholderName?: string | null, policyMaxSpend?: number | null, policy?: string | null, negotiationStatus?: string | null, estimateDecision?: Types.EstimateDecision | null, additionalDamage?: boolean | null, circumstances?: string | null, shinkaAmount?: number | null, processabilityTriageOutcome?: string | null, processabilityTriageDetails?: string | null, images?: Array<{ __typename?: 'Image', id?: string | null, path?: string | null, imageCategory?: string | null } | null> | null, assets?: Array<{ __typename?: 'Asset', path?: string | null, type?: string | null, valid?: boolean | null } | null> | null, yesNo?: Array<{ __typename?: 'YesNoQuestion', question?: string | null, response?: string | null, typicalAnswer?: string | null, questionId?: string | null } | null> | null, claimDetails?: { __typename?: 'ClaimDetails', estimateStatus?: string | null, claimId?: string | null, dateOfAccident?: string | null, poi?: string | null, isPublishedStage?: boolean | null, phDecision?: { __typename?: 'PhDecision', decision?: string | null, counterOffer?: number | null } | null, validAsset?: { __typename?: 'Asset', path?: string | null, valid?: boolean | null, type?: string | null } | null } | null, vehicle?: { __typename?: 'VehicleDetails', name?: string | null, vin?: string | null, registration?: string | null, mileage?: number | null, valuation?: number | null, dateOfFirstRegistration?: string | null, vehicleIdentifier?: string | null, make?: string | null, model?: string | null, year?: number | null, month?: number | null, modelSubtypeCode?: string | null } | null, estimate?: { __typename?: 'Estimate', id?: string | null, info?: { __typename?: 'EstimateInfo', taxRate?: number | null, estimateType?: string | null, repairLaborRate?: number | null, stripRefitLaborRate?: number | null, paintLaborRate?: number | null, customerLanguage?: string | null, internalLanguage?: string | null, flags?: Array<string> | null, internalDamage?: string | null, taxStrategy?: { __typename?: 'TaxStrategy', strategy: Types.TaxStrategies, rate?: number | null, bands?: Array<{ __typename?: 'TaxBand', from: number, to?: number | null, rate: number } | null> | null } | null, repairDataRegion?: { __typename?: 'RepairDataRegion', countryCode?: string | null } | null } | null, paint?: { __typename?: 'EstimatePaint', additionalLaborHours?: number | null, additionalMaterialCost?: number | null } | null, parts?: Array<{ __typename?: 'EstimatePart', name?: string | null, belongsTo?: string | null, operation?: string | null, paintMaterialCost?: number | null, stripRefitLaborHours?: number | null, undeductedStripRefitLaborHours?: number | null, paintLaborHours?: number | null, repairLaborHours?: number | null, replacementPartCost?: number | null, partCategory?: string | null, oePartIdentifier?: string | null, partType?: string | null, partSupplier?: string | null, displayPartIdentifier?: string | null, partManufacturer?: string | null, dataSource?: string | null, internalDisplayName?: string | null, customerDisplayName?: string | null, partOptions?: Array<string | null> | null, partSelection?: string | null, paintLevel?: string | null, paintPartMaterial?: string | null, adjustments?: Array<{ __typename?: 'EstimateAdjustment', type?: Types.EstimateAdjustmentType | null, triggerType?: Types.EstimateAdjustmentTrigger | null, appliesTo?: string | null, delta: number, triggerId?: string | null, strategy?: { __typename?: 'EstimateAdjustmentStrategy', name: Types.AdjustmentStrategyName, value?: number | null, percentage?: number | null, minimum?: number | null } | null } | null> | null, auxParts?: Array<{ __typename?: 'AuxPart', name?: string | null, belongsTo?: string | null, operation?: string | null, paintMaterialCost?: number | null, stripRefitLaborHours?: number | null, undeductedStripRefitLaborHours?: number | null, paintLaborHours?: number | null, repairLaborHours?: number | null, replacementPartCost?: number | null, partCategory?: string | null, oePartIdentifier?: string | null, partType?: string | null, partSupplier?: string | null, displayPartIdentifier?: string | null, partManufacturer?: string | null, dataSource?: string | null, internalDisplayName?: string | null, customerDisplayName?: string | null, partOptions?: Array<string | null> | null, partSelection?: string | null, paintLevel?: string | null, paintPartMaterial?: string | null, adjustments?: Array<{ __typename?: 'EstimateAdjustment', type?: Types.EstimateAdjustmentType | null, triggerType?: Types.EstimateAdjustmentTrigger | null, appliesTo?: string | null, delta: number, triggerId?: string | null, strategy?: { __typename?: 'EstimateAdjustmentStrategy', name: Types.AdjustmentStrategyName, value?: number | null, percentage?: number | null, minimum?: number | null } | null } | null> | null } | null> | null } | null> | null, additionalParts?: Array<{ __typename?: 'EstimateAdditionalParts', name?: string | null, belongsTo?: string | null, minCost?: number | null, maxCost?: number | null, labourHours?: number | null } | null> | null, operations?: Array<{ __typename?: 'EstimateOperation', displayDescription?: string | null, type: Types.EstimateOperationType, triggerType: Types.EstimateOperationTriggerType, quantity: number, cost?: number | null, rowType?: string | null, triggers?: Array<{ __typename?: 'EstimateOperationTrigger', part?: string | null, operation?: string | null } | null> | null, labor?: { __typename?: 'OperationLabor', hours: number, rate: number } | null } | null> | null, adjustments?: Array<{ __typename?: 'EstimateAdjustment', type?: Types.EstimateAdjustmentType | null, triggerType?: Types.EstimateAdjustmentTrigger | null, appliesTo?: string | null, delta: number, triggerId?: string | null, strategy?: { __typename?: 'EstimateAdjustmentStrategy', name: Types.AdjustmentStrategyName, value?: number | null, percentage?: number | null, minimum?: number | null } | null } | null> | null } | null, estimatesByType?: Array<{ __typename?: 'Estimate', id?: string | null, info?: { __typename?: 'EstimateInfo', estimateType?: string | null, amountIncludingTax?: number | null } | null } | null> | null, coaEstimateDisplay?: { __typename?: 'CoaEstimateDisplay', result?: boolean | null } | null, settlement?: { __typename?: 'Settlement', decision?: Types.SettlementDecision | null, outOfScopeReason?: Types.OutOfScopeReason | null, outOfScopeDetails?: string | null, noTotalLossDecisionReason?: Types.NoTotalLossDecisionReason | null } | null, vrmCheck?: { __typename?: 'VrmCheck', outcome?: Types.VrmCheckOutcome | null } | null } | null };


export const GetClaimDocument = gql`
    query getClaim($id: String) {
  claim(id: $id) {
    id
    clientId
    clientClaimId
    stage
    status
    tlIndicator
    maximumRepairSpend
    policyholderName
    policyMaxSpend
    policy
    negotiationStatus
    estimateDecision
    additionalDamage
    circumstances
    shinkaAmount
    images {
      id
      path
      imageCategory
    }
    assets {
      path
      type
      valid
    }
    yesNo {
      question
      response
      typicalAnswer
      questionId
    }
    claimDetails {
      estimateStatus
      phDecision {
        decision
        counterOffer
      }
      claimId
      dateOfAccident
      poi
      isPublishedStage
      validAsset {
        path
        valid
        type
      }
    }
    vehicle {
      name
      vin
      registration
      mileage
      valuation
      dateOfFirstRegistration
      vehicleIdentifier
      make
      model
      year
      month
      modelSubtypeCode
    }
    estimate {
      id
      info {
        taxRate
        taxStrategy {
          strategy
          rate
          bands {
            from
            to
            rate
          }
        }
        estimateType
        repairLaborRate
        stripRefitLaborRate
        paintLaborRate
        customerLanguage
        internalLanguage
        flags
        repairDataRegion {
          countryCode
        }
        internalDamage
      }
      paint {
        additionalLaborHours
        additionalMaterialCost
      }
      parts {
        name
        belongsTo
        operation
        paintMaterialCost
        stripRefitLaborHours
        undeductedStripRefitLaborHours
        paintLaborHours
        repairLaborHours
        replacementPartCost
        partCategory
        oePartIdentifier
        partType
        partSupplier
        displayPartIdentifier
        partManufacturer
        dataSource
        internalDisplayName
        customerDisplayName
        partOptions
        partSelection
        paintLevel
        paintPartMaterial
        adjustments {
          type
          triggerType
          appliesTo
          delta
          triggerId
          strategy {
            name
            value
            percentage
            minimum
          }
        }
        auxParts {
          name
          belongsTo
          operation
          paintMaterialCost
          stripRefitLaborHours
          undeductedStripRefitLaborHours
          paintLaborHours
          repairLaborHours
          replacementPartCost
          partCategory
          oePartIdentifier
          partType
          partSupplier
          displayPartIdentifier
          partManufacturer
          adjustments {
            type
            triggerType
            appliesTo
            delta
            triggerId
            strategy {
              name
              value
              percentage
              minimum
            }
          }
          dataSource
          internalDisplayName
          customerDisplayName
          partOptions
          partSelection
          paintLevel
          paintPartMaterial
        }
      }
      additionalParts {
        name
        belongsTo
        minCost
        maxCost
        labourHours
      }
      operations {
        displayDescription
        type
        triggerType
        triggers {
          part
          operation
        }
        quantity
        cost
        labor {
          hours
          rate
        }
        rowType
      }
      adjustments {
        type
        triggerType
        appliesTo
        delta
        triggerId
        strategy {
          name
          value
          percentage
          minimum
        }
      }
    }
    estimatesByType {
      id
      info {
        estimateType
        amountIncludingTax
      }
    }
    processabilityTriageOutcome
    processabilityTriageDetails
    coaEstimateDisplay {
      result
    }
    settlement {
      decision
      outOfScopeReason
      outOfScopeDetails
      noTotalLossDecisionReason
    }
    vrmCheck {
      outcome
    }
  }
}
    `;

/**
 * __useGetClaimQuery__
 *
 * To run a query within a React component, call `useGetClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClaimQuery(baseOptions?: Apollo.QueryHookOptions<GetClaimQuery, GetClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimQuery, GetClaimQueryVariables>(GetClaimDocument, options);
      }
export function useGetClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimQuery, GetClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimQuery, GetClaimQueryVariables>(GetClaimDocument, options);
        }
export type GetClaimQueryHookResult = ReturnType<typeof useGetClaimQuery>;
export type GetClaimLazyQueryHookResult = ReturnType<typeof useGetClaimLazyQuery>;
export type GetClaimQueryResult = Apollo.QueryResult<GetClaimQuery, GetClaimQueryVariables>;